<style lang="less">
	@import "../assets/css/about.less";
</style>
<template>
	<div class="about">
		<div class="banner">
			<img src="../assets/img/banner3.jpg" />
			<div class="text">
				<p>慧眼识人，慧心阅人</p>
			</div>
		</div>
		<div class="clearfix content_wrap">
			<div class="content w1100">
				<div class="hr"></div>
				<div class="inner">
					<div class="my_introduce">
						<h3>我们是做什么的</h3>
						<article>北京慧阅信息服务有限公司是一家专注于为行业客户提供身份认证解决方案的高新技术企业。慧阅通过整合生物特征识别和云计算技术搭建身份认证云服务平台。致力于为各行业客户提供准确、快捷、经济、安全的身份验证云服务解决方案。为传统业务互联网化、线下业务线上化提供必需的基础服务；帮助老百姓实现足不出户办理业务。</article>
					</div>
					<div class="my_enterprise_spirit">
						<h3>我们的企业精神</h3>
						<ul class="clearfix">
							<li>诚信</li>
							<li>学习</li>
							<li>创新</li>
							<li>坚持</li>
						</ul>
					</div>
					<!-- <div class="my_desire">
						<h3>我们的企业愿景</h3>
						<p>让老百姓不跑现场、不排队，随时随地都能办理业务！</p>
					</div> -->
					<div class="qualifications">
						<h3>企业资质</h3>
						<div class="clearfix">
							<div class="img_wrap"><img src="../assets/img/index_gx1.png" /></div>
							<div class="img_wrap"><img src="../assets/img/index_gx2.jpg" /></div>


						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		name:'about',
		data() {
			return {

			};
		},
		created(){

		},
		computed: {

		},
		methods:{

		}
	}
</script>



// WEBPACK FOOTER //
// src/components/about.vue